/**
 * @author 冷 (https://github.com/LengYXin)
 * @email [lengyingxin8966@gmail.com]
 * @create date 2021-05-06 23:00:13
 * @modify date 2021-05-06 23:00:13
 * @desc 全局引入的 antd 组件 用那个引入那个
 */
import ProLayout, { SettingDrawer } from '@ant-design-vue/pro-layout';
import { Affix, Alert, AutoComplete, Avatar, BackTop, Badge, Breadcrumb, Button, Calendar, Card, Carousel, Cascader, Checkbox, Col, Collapse, ConfigProvider, DatePicker, Descriptions, Divider, Drawer, Dropdown, Empty, FormModel, Icon, Input, InputNumber, Layout, List, Menu, message, Modal, notification, PageHeader, Pagination, Popconfirm, Popover, Progress, Radio, Result, Row, Select, Skeleton, Slider, Space, Spin, Statistic, Steps, Switch, Table, Tabs, Tag, Tooltip, Transfer, Tree, TreeSelect, Upload, } from 'ant-design-vue';
import Base from 'ant-design-vue/es/base';
import Momentjs from 'moment';
import Vue from 'vue';
const components = [
    Base,
    Tag,
    Descriptions,
    Badge,
    Calendar,
    Popover,
    Result,
    Breadcrumb,
    BackTop,
    Slider,
    Alert,
    Layout,
    PageHeader,
    Skeleton,
    Tooltip,
    Avatar,
    Button,
    Card,
    Checkbox,
    Col,
    DatePicker,
    Divider,
    Dropdown,
    FormModel,
    Icon,
    Input,
    InputNumber,
    List,
    Menu,
    Modal,
    Pagination,
    Popconfirm,
    Radio,
    Row,
    Select,
    Spin,
    Statistic,
    Steps,
    Switch,
    Table,
    Transfer,
    Tabs,
    Upload,
    Drawer,
    Badge,
    Progress,
    Carousel,
    ConfigProvider,
    Empty,
    Space,
    Tree,
    TreeSelect,
    AutoComplete,
    Cascader,
    Collapse,
    Affix,
];
components.map(function (component) {
    // @ts-ignore
    Vue.use(component);
});
message.config({ top: '61px' });
notification.config({ top: '61px' });
Vue.component('ProLayout', ProLayout);
Vue.component('SettingDrawer', SettingDrawer);
Vue.prototype.moment = Momentjs;
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$destroyAll = Modal.destroyAll;
